import { createRouter, createWebHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'dashboard',
    component: () => import('@/views/Dashboard.vue'),
    meta: { title: '数据驾驶舱', icon: 'fa-th-large' }
  },
  {
    path: '/monitor-2d',
    name: 'monitor2d',
    component: () => import('@/views/Monitor2D.vue'),
    meta: { title: '2D施工现场监控', icon: 'fa-map-marked-alt' }
  },
  {
    path: '/monitor-3d',
    name: 'monitor3d',
    component: () => import('@/views/Monitor3D.vue'),
    meta: { title: '3D机房实时监控', icon: 'fa-cube' }
  },
  {
    path: '/procurement',
    name: 'procurement',
    component: () => import('@/views/Procurement.vue'),
    meta: { title: '采购进度监控', icon: 'fa-calendar-alt' }
  },
  {
    path: '/goods',
    name: 'goods',
    component: () => import('@/views/GoodsManagement.vue'),
    meta: { title: '货物管理', icon: 'fa-boxes' }
  }
]

const router = createRouter({
  history: createWebHistory((import.meta as any).env.BASE_URL),
  routes,
  scrollBehavior(_to, _from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    return { top: 0 }
  }
})

// 路由守卫 - 更新页面标题
router.beforeEach((to, _from, next) => {
  const title = to.meta.title as string
  if (title) {
    document.title = `${title} - 中卫算力中心`
  }
  next()
})

export default router